<template>
    <footer>
        <div class="footer-container">
            <ul>
                <li v-for="item in list" :key="item.title" class="footer-item">
                    <div class="title">
                        <p>{{ item.title }}</p>
                    </div>
                    <div v-for="link in item.links" :key="link" class="content"><a href="#" class="">{{ link }}</a>
                    </div>
                </li>
            </ul>
            <section class="copyright">
                <div>
                    <p>
                        <span>已经到底啦~</span>
                    </p>
                    <!-- <p><span>北京尽微致广信息技术有限公司 &nbsp; 联系方式：010-86208376</span><span>地址：北京市朝阳区望京SOHO T3</span></p> -->
                </div>
            </section>
        </div>
    </footer>
    <back-top></back-top>
</template>

<script>
import backTop from '@/components/backTop.vue'
export default {
  components: { backTop },
    name: "footer-layout",
    data() {
        return {
            list: [
                {
                    title: "MasterGo", links: [
                        "界面设计",
                        "交互原型",
                        "设计系统",
                        "团队协作"
                    ]
                },
                {
                    title: "产品对比", links: [
                        "产品对比",
                        "对比 Sketch",
                        "对比 Figma",
                        "对比 Adobe XD"
                    ]
                },
                {
                    title: "资源", links: [
                        "定价",
                        "向团队介绍",
                        "资源社区",
                        "团队协作",
                        "视频教程",
                        "帮助中心",
                        "更新日志",
                        "下载",
                    ]
                },
                {
                    title: "关于我们", links: [
                        "博客",
                        "加入我们",
                        "微信公众号",
                        "服务协议",
                        "隐私协议"
                    ]
                },
                {
                    title: "联系我们", links: [
                        "意见反馈",
                        "商务合作",
                        "team@bd.mastergo.com",
                        "企业客户咨询"
                    ]
                },

            ],
        }
    },
}
</script>

<style scoped>
footer {
    padding: 0 2rem;
}

.footer-container {
    padding: 0 5%;
    text-align: left;
    max-width: 1200px;
    margin: 2rem auto 0;
}

.footer-container>ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;
    margin: 0;
    padding-top: 1rem;
}

.footer-container>ul>li {
    width: 135px;
    margin: 20px 0;
}

.footer-container>ul>li .title {
    font-size: 16px;
    text-decoration: none;
    font-weight: 700;
}

.footer-container>ul>li .content a{
    color: #12112790;
}
.footer-container>ul>li .content a:hover{
    color: var(--primaryColor);
}
.footer-container>ul>li .content {
    font-size: 14px;
    margin-top: 16px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
}

.footer-container>.copyright {
    padding: 1rem 0 1rem;
    border-top: 1px solid rgba(0, 0, 0, .1);
    color: #aaa;
    text-align: center;
}

@media (max-width: 765px) {
    footer {
        padding: 0 1rem;
    }
}
</style>